import React from 'react';

const LoadingSpinner = ({ 
  size = 40, 
  color = '#2aa7a1', 
  text = 'Loading...', 
  showText = true,
  containerStyle = {},
  textStyle = {}
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px',
      fontFamily: 'Poppins, sans-serif',
      ...containerStyle
    }}>
      <div style={{
        width: `${size}px`,
        height: `${size}px`,
        border: `4px solid #f3f3f3`,
        borderTop: `4px solid ${color}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      {showText && (
        <div style={{
          fontSize: '16px', 
          color: 'rgba(75,75,75,1)', 
          fontFamily: 'Poppins, sans-serif',
          fontWeight: '500',
          ...textStyle
        }}>
          {text}
        </div>
      )}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner; 